import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import HomePage from './pages/index';
import LoginPage from './pages/login';
import GerenciarUsuariosPage from './pages/gerenciarUsuarios';
import GerenciarRamosPage from './pages/gerenciarRamos';
import GerenciarAgencias from './pages/gerenciarAgencias';
import GerenciarClientesPage from './pages/gerenciarClientes';
import RotaProtegida from './pages/sistema/RotaProtegida'; // Importando o novo componente
import GerenciarApolicesPage from './pages/gerenciarApolices';
import EditarApolice from './pages/editarApolice';
import GerenciarSeguradorasPage from './pages/gerenciarSeguradoras';
import FinanceiroPage from './pages/financeiro';
import GerenciarVisitasProspeccao from './pages/gerenciarVisitasProspeccao';
import GerenciarEmpresasPage from './pages/gerenciarEmpresas';
import GerenciarMetas from './pages/gerenciarMetas';
import DesempenhoPage from './pages/verificarDesempenhoColaborador';
import RelatorioPage from './pages/relatorios/RelatorioPage';
import GerenciarCredenciaisPage from './pages/GerenciarCredenciaisPage';
import GerenciarCoberturas from './pages/gerenciarCoberturas';
import TestePage from './pages/teste';
import GerenciarCargosPage from './pages/gerenciarCargos';
import NaoAutorizado from './pages/sistema/NaoAutorizado';
import GerenciarAcessosPage from './pages/gerenciarAcessos';
import PrivateRoute from './components/PrivateRoute';
import DetalharClientePage from './pages/detalharCliente';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Rotas Públicas */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/nao-autorizado" element={<NaoAutorizado />} />

          {/* --- Início das Rotas Protegidas --- */}

          {/* Grupo de rotas que só precisam de autenticação (sem permissão específica) */}
          <Route element={<RotaProtegida permissoesNecessarias={[]} />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/desempenho" element={<DesempenhoPage />} />
            <Route path="/teste" element={<TestePage />} />
          </Route>

          {/* Grupo de rotas para gerenciamento de usuários */}
          <Route element={<RotaProtegida permissoesNecessarias={[{ entidade: 'usuario', acao: 'visualizar' }]} />}>
            <Route path="/usuarios" element={<GerenciarUsuariosPage />} />
            <Route path="/acessos" element={<GerenciarAcessosPage />} />
          </Route>

          {/* Grupo de rotas para gerenciamento de apólices */}
          <Route element={<RotaProtegida permissoesNecessarias={[{ entidade: 'apolice', acao: 'visualizar' }]} />}>
            <Route path="/apolices" element={<GerenciarApolicesPage />} />
            {/* A rota de edição pode exigir uma permissão diferente, se necessário */}
            <Route path="/apolices/editar/:id" element={<EditarApolice />} />
          </Route>

          {/* Grupo de rotas para cadastros gerais */}
          <Route element={<RotaProtegida permissoesNecessarias={[{ entidade: 'parametro', acao: 'visualizar' }]} />}>
            <Route path="/ramos" element={<GerenciarRamosPage />} />
            <Route path="/agencias" element={<GerenciarAgencias />} />
            <Route path="/seguradoras" element={<GerenciarSeguradorasPage />} />
            <Route path="/empresas" element={<GerenciarEmpresasPage />} />
            <Route path="/coberturas" element={<GerenciarCoberturas />} />
          </Route>

          {/* Exemplo de rotas com permissões diferentes */}
          <Route element={<RotaProtegida permissoesNecessarias={[{ entidade: 'cliente', acao: 'visualizar' }]} />}>
            <Route path="/clientes" element={<GerenciarClientesPage />} />
          </Route>

          <Route element={<RotaProtegida permissoesNecessarias={[{ entidade: 'financeiro', acao: 'visualizar' }]} />}>
            <Route path="/financeiro" element={<FinanceiroPage />} />
          </Route>

          <Route element={<RotaProtegida permissoesNecessarias={[{ entidade: 'prospeccao', acao: 'visualizar' }]} />}>
            <Route path="/visitas-prospeccao" element={<GerenciarVisitasProspeccao />} />
          </Route>

          <Route element={<RotaProtegida permissoesNecessarias={[{ entidade: 'meta', acao: 'visualizar' }]} />}>
            <Route path="/metas" element={<GerenciarMetas />} />
          </Route>

          <Route element={<RotaProtegida permissoesNecessarias={[{ entidade: 'relatorio', acao: 'visualizar' }]} />}>
            <Route path="/relatorios" element={<RelatorioPage />} />
          </Route>

          <Route element={<RotaProtegida permissoesNecessarias={[{ entidade: 'credencial', acao: 'visualizar' }]} />}>
            <Route path="/credenciais" element={<GerenciarCredenciaisPage />} />
          </Route>

          <Route element={<RotaProtegida permissoesNecessarias={[{ entidade: 'cargo', acao: 'visualizar' }]} />}>
            <Route path="/cargos" element={<GerenciarCargosPage />} />
          </Route>

          <Route path="/clientes/detalhar/:id" element={<PrivateRoute><DetalharClientePage /></PrivateRoute>} />
          {/* --- Fim das Rotas Protegidas --- */}
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
